import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';
import { FaArrowsAltH } from 'react-icons/fa';

import Exit from '../subComponents/Exit';
import SocialIcons from '../subComponents/SocialIcons';
import floatImg from '../assets/Images/Saly-35.png';
import myPic from '../assets/Images/mypic.png';
import Skills from '../subComponents/Skills';

const transition = { duration: 1.4, ease: [0.6, 0.01, -0.05, 0.9] };

const Container = styled.div`
  background-color: ${(props) => props.theme.body};
  width: 100vw;
  height: 100vh;
  position: relatve;
  align-items: center;
  overflow: hidden;
`;

const float = keyframes`
 0% {transform : translateY(-10px)}
 50% {transform : translateY(15px) translateX(15px)}
 100% {transform : translateY(-10px)}
`;

export const Img = styled.div`
  position: fixed;
  bottom: -34px;
  right: 4.6%;
  width: 43.9vw;

  img {
    width: 100%;
    height: auto;
  }

  h1 {
    font-family: 'Syne', sans-serif;
    position: absolute;
    bottom: -8px;
    right: 7%;
    font-size: calc(3rem + 4vw);
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.1)`};
  }

  @media (max-width: 951px) {
    width: 50vw;
    height: auto;
  }

  @media (max-width: 600px) {
    width: 77.7vw;
    height: auto;
  }
`;

const Text = styled(motion.div)`
  display: flex;
  position: absolute;
  right: 0;
  top: 30%;
  width: 55vw;
  height: 45vh;
  justify-content: center;
  align-items: center;
  font-family: 'Ubuntu Mono', monospace;
  font-size: calc(0.6rem + 1vw);
  text-shadow: 0px 0px 4px ${(props) => props.theme.body};
  color: ${(props) => props.theme.text};
  padding: 0rem 3rem;
  line-height: 1.5;

  backdrop-filter: blur(4px);
  border-top: 1px solid ${(props) => `rgba(${props.theme.textRgba}, 0.5)`};
  border-left: 1px solid ${(props) => `rgba(${props.theme.textRgba}, 0.4)`};
  border-right: 1px solid ${(props) => `rgba(${props.theme.textRgba}, 0.1)`};
  border-bottom: 2px solid ${(props) => `rgba(${props.theme.textRgba}, 0.2)`};
  box-shadow: 0 9px 15px ${(props) => `rgba(${props.theme.textRgba}, 0.1)`};
  border-radius: 35px 0px 0px 35px;
  z-index: 5;

  @media (max-width: 600px) {
    top: 14rem;
    width: 75vw;
    padding: 1.6rem;
  }
`;

const FloatImg = styled.div`
  position: absolute;
  top: 10%;
  right: 5%;
  width: 20vw;
  animation: ${float} 4s ease infinite;
  z-index: 2;
  cursor: grab;

  img {
    width: 100%;
    height: auto;
  }

  @media (max-width: 697px) {
    top: 20%;
    right: 1%;
    width: 30vw;
  }
`;

const Note = styled(motion.div)`
  display: flex;
  position: absolute;
  bottom: 0%;
  right: 2%;
  font-family: 'Syne', sans-serif;
  font-size: calc(0.3rem + 1vw);
  color: ${(props) => `rgba(${props.theme.textRgba}, 0.5)`};

  .arrow {
    font-size: calc(0.8rem + 1vw);
    margin-left: 0.7rem;
  }
`;

const AboutPage = () => {
  return (
    <Container>
      <motion.div exit={{ opacity: 0 }}>
        <Exit />
        <SocialIcons />
      </motion.div>

      <Img>
        <motion.img
          src={myPic}
          alt="About Link"
          animate={{
            x: '-120%',
            width: '80vh',
            transition: { delay: 0, ...transition }
          }}
          exit={{ opacity: 0 }}
        />
        <motion.h1
          animate={{
            y: '-73vh',
            x: '-20vw',
            transition: { delay: 0, ...transition }
          }}
          exit={{ opacity: 0 }}
        >
          ABOUT
        </motion.h1>
      </Img>

      <Text
        initial={{
          x: 1000,
          opacity: 0
        }}
        animate={{
          x: 0,
          opacity: 1,
          transition: { type: 'spring', delay: 0.6, ...transition }
        }}
        exit={{ x: 900, opacity: 0 }}
        transition={transition}
      >
        <p>
          Hi, my full name is Shane Del Moira Santianez Mantua. I'm a
          17-year-old self-taught frontend developer who started learning
          programming and web development in July 2021 and has since earned a
          total of 7 certificates in HTML, CSS, and Javascript. In my three
          months of coding, I made 6 fully functional responsive websites and
          learned 5 libraries along the way. I’m currently looking for
          opportunities to gain experience and expand my skill set in a
          professional environment.
        </p>
      </Text>

      <FloatImg>
        <motion.img
          initial={{
            y: -500,
            opacity: 0
          }}
          animate={{
            y: 0,
            opacity: 1,
            transition: { delay: 0.6, ...transition }
          }}
          exit={{ y: -600, opacity: 0 }}
          transition={transition}
          drag
          dragConstraints={{
            top: -60,
            left: -550,
            right: 20,
            bottom: 10
          }}
          whileDrag={{ scale: 1.2 }}
          src={floatImg}
          alt="Floating Image"
        />
      </FloatImg>

      <motion.div exit={{ opacity: 0 }}>
        <Skills />
        <Note 
        initial={{opacity: 0}}
        animate={{opacity: 1, transition: { delay: 2}}}>
          <p>Drag to see more</p>
          <FaArrowsAltH className="arrow" />
        </Note>
      </motion.div>
    </Container>
  );
};

export default AboutPage;
